import { useTranslation } from 'react-i18next';
import { AlertTriangle, RotateCw } from 'lucide-react';

/**
 * House error/retry state for the Advance COD tab. Shown when the financing
 * summary query FAILS (network blip, 500, or a 403 for a permission-less
 * sub-user) — a transient API error must never fall through to the State B
 * pre-activation card, which would give an already-activated merchant false
 * financial guidance. Dashed-empty-state shell plus a retry that refetches
 * the summary.
 */
function AdvanceLoadError({ onRetry }: { onRetry?: () => void }) {
  const { t } = useTranslation();
  return (
    <div
      className='flex flex-col items-center justify-center gap-3 rounded-2xl border border-dashed border-[rgb(200,200,196)] bg-white px-6 py-12 text-center'
      data-testid='advance-cod-load-error'
    >
      <div className='flex h-12 w-12 items-center justify-center rounded-xl bg-[rgb(245,245,243)]'>
        <AlertTriangle className='h-6 w-6 text-[rgb(115,123,140)]' />
      </div>
      <p className='m-0 text-[15px] font-bold text-[rgb(57,57,60)]'>
        {String(t('advance_cod_load_error_title'))}
      </p>
      <p className='m-0 max-w-[420px] text-[13px] text-[rgb(115,123,140)]'>
        {String(t('advance_cod_load_error_body'))}
      </p>
      {onRetry ? (
        <button
          type='button'
          onClick={onRetry}
          className='mt-1 inline-flex items-center gap-2 rounded-[11px] bg-[rgb(237,224,74)] px-5 py-2.5 text-[13.5px] font-bold text-[rgb(57,57,60)] transition-colors hover:bg-[rgb(230,217,60)]'
        >
          <RotateCw className='h-4 w-4' strokeWidth={2.2} />
          {String(t('advance_cod_retry'))}
        </button>
      ) : null}
    </div>
  );
}

export default AdvanceLoadError;
